
    // Auto-generated branding config.
    /* eslint-disable */
const generatedBranding = {
  isActive: false,
  brandName: "",
  meta: {
    title: "",
    description: "",
    shortName: "",
    footerText: false,
  },
  urls: {
    logo: "",
    favicon: "",
    image_192: "",
    image_512: "",
  },
  theme: null
};

export default generatedBranding;
